import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-certificate-view',
  templateUrl: './training-certificate-view.component.html',
  styleUrls: ['./training-certificate-view.component.css']
})
export class TrainingCertificateViewComponent implements OnInit {
  title="Personnel Detail";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/training-certificate/training-certificate-view/training-certificate-view.component.ts